import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useModelInfo } from '../common/ModelInfoContext';
import ConfigTrimFiltering from './withTrimFiltering/Config';
import ConfigWithoutFiltering from './withoutTrimFiltering/Config';
import ConfigPage from './ConfigPage';

const Config = props => {
  const { config, matrix, disclaimer, features } = props;
  const {
    enableTrimFiltering,
    isDefaultRenderMode,
    featureGroup
  } = useModelInfo();
  const { driveTypes, engines, bodyTypes, motorizations } = config;

  return (
    <ConfigPage routeName="CONFIG">
      {({ onChange, onTrimFilteringChange, onDetails }) => (
        <React.Fragment>
          {enableTrimFiltering ? (
            <ConfigTrimFiltering
              matrix={matrix}
              config={config}
              disclaimer={disclaimer}
              features={features}
              type={featureGroup}
              onChange={onTrimFilteringChange}
            />
          ) : (
            <ConfigWithoutFiltering
              engines={isDefaultRenderMode ? engines : []}
              driveTypes={isDefaultRenderMode ? driveTypes : []}
              bodyTypes={bodyTypes}
              motorizations={motorizations}
              disclaimer={disclaimer}
              features={features}
              featureGroup={featureGroup}
              onChange={onChange}
              onDetails={onDetails}
            />
          )}
        </React.Fragment>
      )}
    </ConfigPage>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { config, disclaimers, matrix } = state;
  const disclaimer = disclaimers.simple;
  return {
    config,
    matrix,
    disclaimer,
    ...ownProps
  };
};

export default withRouter(connect(mapStateToProps)(Config));
